import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useConfirm } from '../../contexts/confirm.context';

export const Confirm = () => {
  const [setShowConfirm, showConfirm] = useConfirm();
  const [processing, setProcessing] = useState(false);

  if (!showConfirm) return null;

  const {
    onConfirm,
    onCancel,
    confirmText = 'CONFIRM',
    cancelText = 'CANCEL',
    message,
    title,
    error,
  } = showConfirm;

  const handleClose = () => {
    onCancel?.();
    setShowConfirm(null);
  };

  return (
    <Dialog open={Boolean(showConfirm)} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {message}
        {error ? (
          <Alert sx={{ mt: '1rem' }} severity="error">
            {error}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={processing}
          variant="outlined"
          onClick={handleClose}
          color="primary"
          className="focus:outline-none"
        >
          {cancelText}
        </Button>
        <LoadingButton
          onClick={async () => {
            setProcessing(true);
            try {
              await onConfirm?.();
            } finally {
              setProcessing(false);
            }
            setShowConfirm(null);
          }}
          color="primary"
          variant="contained"
          loading={processing}
          className="focus:outline-none"
        >
          {confirmText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
